import React from "react";
import Lazycover from "components/lazycover";
import ContentWrapper from "components/content-wrapper";
import StickyBlock from "components/sticky-block";
import s from "./index.module.scss";

const Photo = ({ title, image, preview, copy, i }) => (
	<StickyBlock zIndex={100 - i}>
		<ContentWrapper className={s.wrapper}>
			<div className={s.meta}>
				<p className={s.title}>{title}</p>
				<p className={s.copy}>{copy}</p>
			</div>
		</ContentWrapper>

		<div className={s.shadow} />

		<Lazycover contain image={image} />

		<div
			className={s.background}
			style={{
				backgroundImage: `url(${preview})`
			}}
		/>
	</StickyBlock>
);

export default Photo;
